import './Toolbar.scss';

import React from 'react';

interface Props {
    contentLeft?: React.ReactNode;
    contentRight?: React.ReactNode;
}

const Toolbar: React.FC<Props> = ({ contentLeft, contentRight }) => {
    return (
        <div className="db-admin-toolbar">
            <div className="main-flex">
                <div className="left-flex">{contentLeft}</div>
                <div className="right-flex">{contentRight}</div>
            </div>
        </div>
    );
};

export default Toolbar;
